// LiveStreamAnimationGift.js
'use strict';
import { connect } from 'react-redux';

import LiveStreamAnimationGift from '../component/LiveStreamAnimationGift.jsx';

import getLiveStreamData from '../selector/getLiveStreamData.js';
import getListData from '../selector/getListData.js';
import getGiftData from '../selector/getGiftData.js';
import getMeData from '../selector/getMeData.js';
import { livestreamNoticeType } from '../resource/liveStreamConstants.js';
import { GiftUiType } from '../resource/giftConstants.js';

const mapStateToProps = (state, { streamId }) => {
  const noticeType = livestreamNoticeType.GIFT_NOTICE;
  const giftNoticeIds =
    getListData(state, ['liveStream', streamId, noticeType], 'itemIds') || [];
  const giftNoticeId = giftNoticeIds[0];
  const giftNoticeSelectPath = [streamId, noticeType, giftNoticeId];
  const giftId = getLiveStreamData(state, giftNoticeSelectPath, 'giftId');
  const senderId = getLiveStreamData(state, giftNoticeSelectPath, 'senderId');
  const meId = getMeData(state, 'id');
  const isSender = !!(senderId && meId && senderId === meId);

  // for gift without ui_type fallback to .png
  const isStaticGift = !!getLiveStreamData(
    state,
    giftNoticeSelectPath,
    'isStaticGift'
  );
  const giftImage = giftId
    ? getGiftData(state, giftId, isStaticGift ? 'image' : 'largeImage')
    : '';

  // PAG gift support
  const isPagGift = giftId
    ? getGiftData(state, giftId, 'uiType') === GiftUiType.PAG
    : false;
  const pagImage =
    giftId && isPagGift ? getGiftData(state, giftId, 'pagImage') : '';

  const byteplusUsingPlayer = getLiveStreamData(
    state,
    [streamId, 'byteplus'],
    'usingPlayer'
  );
  const byteplusPlayerVideoHeight = getLiveStreamData(
    state,
    [streamId, 'byteplus', byteplusUsingPlayer],
    'videoHeight'
  );
  const byteplusPlayerVideoWidth = getLiveStreamData(
    state,
    [streamId, 'byteplus', byteplusUsingPlayer],
    'videoWidth'
  );

  return {
    byteplusPlayerVideoWidth,
    byteplusPlayerVideoHeight,
    giftNoticeId,
    giftId,
    streamId,
    isSender,
    giftImage,
    pagImage,
    isPagGift,
    isStaticGift,
    shouldShowMainAsset: getLiveStreamData(
      state,
      giftNoticeSelectPath,
      'shouldShowMainAsset'
    ),
  };
};

export default connect(mapStateToProps, null)(LiveStreamAnimationGift);
